import React from 'react';
import SearchField from '@amzn/meridian/search-field';
import Responsive from '@amzn/meridian/responsive';
import { responsiveProps } from 'src/constants/responsiveProps';
import { SCANNER_RESOLUTION_WIDTH } from 'src/constants/responsiveProps';

interface SearchInputProps {
    searchFieldLabel: string;
    searchFieldPlaceholder: string;
    renderSearchButton: boolean;
    onSubmit: (containerId: string) => void;
    'data-testid'?: string;
}

/**
 * Meridian's SearchField does not forward `data-testid` down to its inner
 * <input> or search <button> (unlike Meridian Input/Button, which pass through
 * `data-*` attributes). So for reliable E2E targeting we wrap the SearchField
 * in a div carrying the `data-testid`; tests then locate the real controls with
 * `[data-testid="<id>"] input` and `[data-testid="<id>"] button`.
 */

interface SearchInputState {
    searchFieldValue: string;
}

type Props = SearchInputProps;

class SearchInput extends React.Component<Props, SearchInputState> {
    constructor(props: Props) {
        super(props);
        this.state = {
            searchFieldValue: ''
        };
    }

    private inputTimeoutHandler: ReturnType<typeof setTimeout> | undefined;

    private setSearchValue = (value: string): void => {
        this.setState({
          searchFieldValue: value
        });

        if (window.screen.width <= SCANNER_RESOLUTION_WIDTH) {
            console.log('screen width', window.screen.width);
            console.log('screen width type', typeof window.screen.width);
            if (this.inputTimeoutHandler) {
                clearTimeout(this.inputTimeoutHandler);
            }
            this.inputTimeoutHandler = setTimeout(() => {
                if (this.state.searchFieldValue.length > 2)
                    this.submitInput();
            }, 100);
        }
    }

    private getInitialState = (): SearchInputState => {
        return {
            searchFieldValue: ''
        };
    }

    private submitInput = () => {
        this.props.onSubmit(this.state.searchFieldValue);
        this.setState(this.getInitialState());
    }

    // A pending auto-submit must not fire once the field is gone
    public componentWillUnmount() {
        clearTimeout(this.inputTimeoutHandler);
    }

    public render() {
        return (
            <Responsive query={"max-width"} props={responsiveProps} >
                {() => (
                    <div data-testid={this.props['data-testid']}>
                        <SearchField
                            inaccessibleAutoFocus={true}
                            type="text"
                            value={this.state.searchFieldValue}
                            onChange={this.setSearchValue}
                            onSubmit={this.submitInput}
                            size="xlarge"
                            label={this.props.searchFieldLabel}
                            placeholder={this.props.searchFieldPlaceholder}
                            searchButton={this.props.renderSearchButton}
                        />
                    </div>
                )}
            </Responsive>
        );
    }
}

export default SearchInput;
